import { Components, Theme } from '@mui/material/styles';

import { spacing } from '../constants/layout';

export const formLabelConfigs: Components<Theme>['MuiFormLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.grey[700],
      fontSize: theme.typography.body2.fontSize,
      fontWeight: theme.typography.body2.fontWeight,
      marginBottom: spacing,

      '&.MuiInputLabel-shrink': {
        color: theme.palette.text.primary,
      },
      '&.Mui-error': {
        color: theme.palette.error.main,
      },
    }),
  },
};
